import verticalMixinForScrollPosition from './verticalMixinForScrollPosition.js'
export default () => ({
    mixins: [verticalMixinForScrollPosition()]//将导入的文件verticalMixinForScrollPosition文件混入到该组件中
});